import React from "react";
import FeedbackProgressPanel from "./FeedbackProgressPanel";

export function isFeedbackEvaluationActive({ loadingFeedback, feedbackPhase }) {
  return Boolean(
    loadingFeedback || feedbackPhase === "loading" || feedbackPhase === "celebrate"
  );
}

export default function FeedbackProgressSlot({
  active,
  progress,
  stage,
  subtitle,
  status,
  slow,
  scrollRef,
}) {
  if (!active) return null;

  return (
    <>
      <div
        ref={scrollRef}
        className="lp-feedback-progress-container"
        style={{ marginTop: 12 }}
      >
        <FeedbackProgressPanel
          progress={progress}
          stage={stage}
          subtitle={subtitle}
          status={status}
        />
      </div>
      {slow ? (
        <div role="status" style={{ marginTop: 8 }}>
          Feedback is taking longer than expected.
        </div>
      ) : null}
    </>
  );
}
